import { createStore } from 'vuex'
import referential from './modules/referential/index'
import auth from './modules/auth/index'
import project from './modules/project/index'

export default createStore({
    modules: {
        referential,
        auth,
        project,
    },
    strict: false
    }
)